import GeneratedQueryServiceApi from "./generated/GeneratedQueryServiceApi"

class QueryServiceApi extends GeneratedQueryServiceApi {

}

export const queryServiceApi = new QueryServiceApi()
